// Codificación de texto para impresoras ESC/POS configuradas en CP850.
// Los comandos ESC/POS ya son bytes de control ASCII y se preservan tal cual.
const cp850 = {
  'á': 0xA0, 'é': 0x82, 'í': 0xA1, 'ó': 0xA2, 'ú': 0xA3,
  'ñ': 0xA4, 'Ñ': 0xA5, '¿': 0xA8, '¡': 0xAD, 'ü': 0x81,
  'Ü': 0x9A, 'ç': 0x87, 'Ç': 0x80, 'Á': 0xB5, 'É': 0x90,
  'Í': 0xD6, 'Ó': 0xE0, 'Ú': 0xE9, 'º': 0xB0, 'ª': 0xA6,
}

export function escposBinaryPayload(content) {
  const bytes = []

  for(let i = 0; i < content.length; i++) {
    const char = content[i]
    const code = content.charCodeAt(i)
    bytes.push(code <= 0x7F ? code : (cp850[char] || 0x3F))
  }

  return new Blob([new Uint8Array(bytes)], { type: 'text/plain' })
}
